import React, { useState } from "react";
import { TextField, Button, Typography, Box, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { requestPasswordReset } from "../../client/api";
import { useGlobalStyles } from "../../theme/global";

const RequestPasswordReset: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const classes = useGlobalStyles();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const result = await requestPasswordReset(email);
      setMessage(result.message);
    } catch (err: any) {
      setError(
        err.response?.data?.message ||
          "An error occurred while sending reset instructions"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, margin: "auto", padding: 2 }}>
      <Typography variant="h5">Reset Password</Typography>
      <br />

      {message && <Alert severity="success">{message}</Alert>}
      {error && <Alert severity="error">{error}</Alert>}

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          sx={{ mb: 2, mt: 2 }}
          disabled={loading}
          className={classes.textFieldLabel}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
          fullWidth
        >
          {loading ? "Sending..." : "Send Reset Instructions"}
        </Button>
      </form>

      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Button variant="text" onClick={() => navigate("/login")}>
          Back to Login
        </Button>
      </Box>
    </Box>
  );
};

export default RequestPasswordReset;
